import { Component, inject, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { UiModule } from '@components/ui/ui-module';
import { Global } from '@services/global.service';
import { Router } from '@services/route.service';
import { User } from '@services/user.service';

@Component({
  selector: 'lgb-collect',
  imports: [
    UiModule,
    RouterModule
  ],
  templateUrl: './collect.html',
  styleUrl: './collect.css',
})
export class Collect {
  readonly router=inject(Router);
  readonly loading=signal(false);
  readonly userService=inject(User);
  readonly globalS=inject(Global);

  unlog(){
    this.loading.set(true);
    this.userService.unlog().subscribe(() => {
      this.loading.set(false);
      this.router.navigate('login');
    });
  }
}
